const DataTableIcon = ({ name, type = 's', title, disabled = false }) => (
  <i className={`fa${type} fa-${name}${disabled ? ' text-secondary opacity-30' : ''}`} title={title}></i>
);

export default DataTableIcon;
